//奇門遁甲共用常數 + helpers — 給 3 個頁面（intro / process / result）共用

//類別 + 事件清單已搬進 DB（models: QimenCategory / QimenEvent）
//  統一透過 FunctionService.getQimenMeta() 拉，回傳結構：
//    { categories: [{ ...category, events: [...] }] }
//  event 欄位：{ eventId, label, targetGates: [...], recommendedPlate,
//              icon, color, isFeatured, order, isActive }
//  後台 /admin/system「奇門事件管理」可 CRUD

//—— 2 種盤別（id 對齊 F-1 type / F-3 plateType：時盤="1"、日盤="2"）——
export const PLATES = [
  {
    id: "1",
    label: "時盤",
    icon: "bi-clock-fill",
    description: "選擇特定一天，找出當天最佳時辰",
  },
  {
    id: "2",
    label: "日盤",
    icon: "bi-calendar2-week-fill",
    description: "選擇日期區間，找出最佳吉日",
  },
];


//—— 3×3 方位網格定義 ——
export const COMPASS_3X3 = [
  { label: "西北", dir: "西北" },
  { label: "北", dir: "北" },
  { label: "東北", dir: "東北" },
  { label: "西", dir: "西" },
  { label: "中宮", dir: "中" },
  { label: "東", dir: "東" },
  { label: "西南", dir: "西南" },
  { label: "南", dir: "南" },
  { label: "東南", dir: "東南" },
];

//—— 內角點座標（viewBox 100×100，給箭頭 SVG 用）——
export const DIR_INNER_CORNER = {
  西北: { x: 33.33, y: 33.33 },
  北: { x: 50, y: 33.33 },
  東北: { x: 66.67, y: 33.33 },
  西: { x: 33.33, y: 50 },
  東: { x: 66.67, y: 50 },
  西南: { x: 33.33, y: 66.67 },
  南: { x: 50, y: 66.67 },
  東南: { x: 66.67, y: 66.67 },
};



